import { createSlideIcon, type IconProps } from '../SlideTypeIcon';
const DEFAULT_COLOR = 'var(--palette-coral-500)';

const Icon24x24 = ({ textColor = DEFAULT_COLOR }: IconProps) => (
  <>
    <circle cx="15.5" cy="15.5" r="4.5" fill={textColor} />
    <rect x="7.23892" y="12.2218" width="9" height="5" fill={textColor} />
    <circle cx="8.5" cy="15.5" r="4.5" fill={textColor} />
    <circle cx="15.5" cy="8.5" r="4.5" fill={textColor} />
    <rect x="9.23209" y="6.74057" width="5" height="5" fill={textColor} />
    <circle cx="8.5" cy="8.5" r="4.5" fill={textColor} />
    <circle cx="10.9759" cy="11.9725" r="4.23548" fill={textColor} />
    <rect
      x="15.2847"
      y="7.73709"
      width="5"
      height="6"
      transform="rotate(90 15.2847 7.73709)"
      fill={textColor}
    />
    <circle cx="13.4676" cy="11.9726" r="4.23548" fill={textColor} />
  </>
);

const Icon32x32 = ({ textColor = DEFAULT_COLOR }: IconProps) => (
  <>
    <circle cx="19.7096" cy="19.5011" r="4.23548" fill={textColor} />
    <rect
      x="11.239"
      y="16.0132"
      width="8.96925"
      height="5.48121"
      fill={textColor}
    />
    <circle cx="12.2355" cy="19.5011" r="4.23548" fill={textColor} />
    <circle cx="19.7096" cy="12.0265" r="4.23548" fill={textColor} />
    <rect
      x="13.2322"
      y="10.5317"
      width="4.98292"
      height="5.48121"
      fill={textColor}
    />
    <circle cx="12.2355" cy="12.0265" r="4.23548" fill={textColor} />
    <circle cx="14.976" cy="15.7638" r="4.23548" fill={textColor} />
    <rect
      x="19.2847"
      y="11.5283"
      width="5.48121"
      height="5.9795"
      transform="rotate(90 19.2847 11.5283)"
      fill={textColor}
    />
    <circle cx="17.4677" cy="15.7638" r="4.23548" fill={textColor} />
  </>
);

export const WordcloudIcon = createSlideIcon(Icon24x24, Icon32x32);
